//React, React Router, Formik
import React from 'react';

//Material UI

//Redux
import {wrapper} from "@store/store";
import {termsPrivacyAndHelpActions} from "@store/TermsPrivacyAndHelp/slice";
import Head from "next/head";
import Privacy from "@modules/privacy/Privacy";
import {UnsetAccessToken} from "@store/Auth/actions";
import {AUTH} from "@helper/constants/routes";
import {getApiUrl} from "@helper/constants/constant";

//Assets

//This method must be implemented for Nprogress to work properly
export const getServerSideProps = wrapper.getServerSideProps(
    store => async (context) => {

        try {
            const response = await fetch(`${getApiUrl(context)}/api/termsPrivacyAndHelp/showPrivacy`, {
                method: 'GET',
            });
            const data = await response.json();
            store.dispatch(termsPrivacyAndHelpActions.setPrivacy(data));
        } catch (e) {
            UnsetAccessToken();
            return {
                redirect: {
                    permanent: false,
                    destination: AUTH.login,
                },
                props:{},
            };
        }
    }
)

const Index = () => {

    return (
        <>
            <Head>
                <title>Privacy</title>
            </Head>
            <Privacy />
        </>
    );
};

export default Index;
